import React, { createContext, useEffect, useRef, useState } from 'react';
import { IModule } from 'redux-dynamic-modules';
import axios from 'axios';
import Spinner from '@core/components-js-only/src/Spinner/Spinner';

declare module globalThis {
  let config: { [key: string]: unknown };
}

export interface ReduxModule extends IModule<any> {
  sagas?: any;
}

export interface AppConfig {
  authApiUrl: string;
  title: string;
  [key: string]: unknown;
}

interface BaseAppWrapperContextValues {
  reduxModules?: React.MutableRefObject<ReduxModule[]>;
  config: AppConfig;
}

export const BaseAppWrapperContext = createContext<BaseAppWrapperContextValues>(
  {
    config: {}
  } as BaseAppWrapperContextValues
);

type BaseAppProviderProps = {
  renderChildren: () => JSX.Element;
};

type BaseAppProviderComp = (props: BaseAppProviderProps) => JSX.Element;

const BaseAppProvider: BaseAppProviderComp = ({ renderChildren }) => {
  const reduxModules = useRef([]);
  const [config, setConfig] = useState({
    loaded: false,
    data: {}
  });

  useEffect(() => {
    const updateConfig = (
      newConfig: AppConfig = { authApiUrl: '', title: '' }
    ) => {
      globalThis.config = {};

      Object.entries(newConfig).forEach(([key, val]) => {
        globalThis.config[key] = val;
      });

      setConfig({ loaded: true, data: newConfig });
    };

    axios
      .get<AppConfig>('config.json', { baseURL: '' })
      .then((r) => updateConfig(r.data))
      .catch(() => updateConfig());
  }, []);

  if (!config.loaded) {
    return <Spinner />;
  }

  return (
    <BaseAppWrapperContext.Provider
      value={{ reduxModules, config: config.data as AppConfig }}
    >
      {renderChildren()}
    </BaseAppWrapperContext.Provider>
  );
};

export const withBaseAppProvider = (WrappedComponent: React.FC<any>) => (
  props: any
) => <BaseAppProvider renderChildren={() => <WrappedComponent {...props} />} />;

export default BaseAppProvider;
